import { useQuery } from '@tanstack/react-query';
import { loansApi } from '@/services/loans-api';

export const useMyLoanSummary = () => {
  return useQuery({
    queryKey: ['loans','my','summary'],
    queryFn: () => loansApi.getMySummary().then(r => r.data),
    staleTime: 60_000,
  });
};

export const useBorrowerLoans = (borrowerId?: number) => {
  return useQuery({
    queryKey: ['loans','borrower', borrowerId],
    enabled: !!borrowerId,
    queryFn: () => loansApi.getByBorrower(borrowerId as number).then(r => r.data),
    staleTime: 30_000,
  });
};

export default { useMyLoanSummary, useBorrowerLoans };